import { cn as e } from "../utils/index.js";
import { Icon as t } from "./icons/icons.js";
import "./icons/index.js";
import { DropdownMenu as n, DropdownMenuContent as r, DropdownMenuGroup as i, DropdownMenuItem as a, DropdownMenuTrigger as o } from "./dropdown-menu.js";
import { SearchBar as s } from "./search-bar.js";
import { useState as c } from "react";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
//#region src/components/dropdown-tag.tsx
function d({ isActive: d, onOpenChange: f, onMenuItemClick: p, name: m, options: h }) {
	let [g, _] = c(!1), [v, y] = c(""), [b, x] = c([]), S = h.map((e) => ({
		...e,
		items: e.items.filter((e) => e.toLowerCase().includes(v.toLowerCase()))
	})).filter((e) => e.items.length > 0), C = S.map((e) => e.label);
	return /* @__PURE__ */ u(n, {
		open: g,
		onOpenChange: (e) => {
			e && f(e), _(e), y(""), x([]);
		},
		children: [/* @__PURE__ */ l(o, {
			asChild: !0,
			children: /* @__PURE__ */ l("button", {
				className: e("h-6 inline-flex items-center rounded-sm justify-center border-(--neutral-50) bg-(--neutral-50) text-(--neutral-500) p-px m-1 ml-0 mr-2", d ? "border-white bg-grad" : "hover:bg-(--seafoam-50)"),
				children: /* @__PURE__ */ u("span", {
					className: e("p-0.75 px-2 font-reg-12 flex items-center gap-1", d ? "text-(--seafoam-600) bg-white font-md-12 rounded-[5px]" : ""),
					children: [m, /* @__PURE__ */ l(t, {
						name: g ? "expand_less" : "expand_more",
						size: "sm"
					})]
				})
			})
		}), /* @__PURE__ */ u(r, {
			className: "w-64",
			children: [/* @__PURE__ */ l("div", {
				className: "px-2 py-2 border-b border-gray-200",
				children: /* @__PURE__ */ l(s, {
					placeholder: "Search criteria",
					onChange: (e) => {
						e.stopPropagation(), y(e.currentTarget.value);
					}
				})
			}), S.length === 0 ? /* @__PURE__ */ l("div", {
				className: "px-2 py-4 text-sm text-center text-gray-500",
				children: "No results found"
			}) : S.map((e) => {
				let n = b.includes(e.label) || v && C.includes(e.label);
				return /* @__PURE__ */ u(i, { children: [/* @__PURE__ */ u("button", {
					className: "focus:bg-accent focus:text-accent-foreground flex w-full cursor-default items-center justify-between rounded-sm px-2 py-1.5 text-sm font-bold outline-hidden select-none hover:bg-(--seafoam-50)",
					onClick: (t) => {
						t.preventDefault(), x((t) => t.includes(e.label) ? t.filter((t) => t !== e.label) : [...t, e.label]);
					},
					children: [e.label, /* @__PURE__ */ l(t, {
						name: n ? "expand_less" : "expand_more",
						size: "sm"
					})]
				}), n && e.items.map((e) => /* @__PURE__ */ l(a, {
					onClick: () => p(e),
					className: "pl-6",
					children: e
				}, e))] }, e.label);
			})]
		})]
	});
}
//#endregion
export { d as DropDownTag };
